export const HEADER_CONSTANTS = {
    LINKS: [{ name: "Home", link: "/" },
    {
        name: "Data Solutions",
        products: [{ name: "Airline Fare", link: "air-travel" }, { name: "Other Travel Data", link: "other-travel-data" }]
    },
    {
        name: "Business Intelligence",
        products: [{ name: "Revenue Management Teams", link: "revenue-management" }, { name: "Distribution Teams", link: "distribution" }, { name: "Network Operations Teamss", link: "network-operations" }]
    },
    {
        name: "Technology",
        products: [{ name: "API", link: "api" }, { name: "Shop Manager", link: "shop-manager" }]
    },
    { name: "Resources", link: "resources" },],
    LOGIN_BUTTON: {
        label: "Log in",
        variant: "outlined"
    }
};
export const TABLEHEADER_SORT_CONSTANTS = ["logs", "more info", "VISUALIZE", "actions", "addtionalInfo", "S.no", "SCHEDULE TIME", "STATUS", "gds", "Chart Groups", "shop Groups", "Group Items"]